"use strict";

exports.__esModule = true;
exports.AllEnabledDeviceListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of all enabled devices to consumers.
 * @component
 */

var AllEnabledDeviceListContext = exports.AllEnabledDeviceListContext = (0, _Utils.createEnhancedContext)({
  propName: "allEnabledDevices"
});